/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  IsItemEquippedChecker,
  IsItemEquippedCheckerInterface,
} from "../IsItemEquippedChecker";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
    ],
    name: "isItemEquipped",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class IsItemEquippedChecker__factory {
  static readonly abi = _abi;
  static createInterface(): IsItemEquippedCheckerInterface {
    return new Interface(_abi) as IsItemEquippedCheckerInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): IsItemEquippedChecker {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as IsItemEquippedChecker;
  }
}
